export default __webpack_public_path__ + "static/media/functional.5b3110dd.webp";